import { axiosInstance } from "../../utils/axiosInstance";

export const fetchAPIResponse = async (data: any, apiURL: string) => {
  try {
    const response = await axiosInstance.post(`${apiURL}`, data);
    return response?.data?.data;
  } catch (error) {
    return error;
  }
};
